import { render } from "./PropertyListPage.vue?vue&type=template&id=46f0e709&ts=true"
import script from "./PropertyListPage.vue?vue&type=script&lang=ts"
export * from "./PropertyListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__